import React from 'react';
import dynamic from 'next/dynamic';
import articles from '../../data/pt-BR/articles.json';
import getInitialContentfulData from '../../utils/helpers/initialDataHelper';
import { contentType, contentfulConstant } from '../../constants/global';

// Dynamically import ArticleDetail to avoid SSR issues
const ArticleDetail = dynamic(
  () => import('../articles/article-detail'),
  { ssr: true }
);

const ARTICLE_SLUGS = {};
articles.forEach((article) => {
  ARTICLE_SLUGS[article.slug] = true;
});

export default function PortugueseDynamicRoute({ articleData, pageContext }) {
  if (!articleData || !articleData.articleCollection?.items?.[0]) {
    return <div>Article not found</div>;
  }

  return <ArticleDetail articleData={articleData} pageContext={pageContext} />;
}

export async function getStaticPaths() {
  const paths = articles.map((article) => ({
    params: { slug: [article.slug] },
  }));

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const articleSlug = Array.isArray(params?.slug) ? params.slug[0] : params?.slug;

  if (!articleSlug || !ARTICLE_SLUGS[articleSlug]) {
    return { notFound: true };
  }

  try {
    const articleData = await getInitialContentfulData(
      contentfulConstant,
      contentType.articlePage,
      'pt-BR',
      { slug: articleSlug }
    );

    if (!articleData?.data?.articleCollection?.items?.[0]) {
      return { notFound: true };
    }

    return {
      props: {
        articleData: articleData.data,
        pageContext: {
          locale: 'pt-BR',
          slug: articleSlug,
          path: `/pt-br/${articleSlug}`,
        },
      },
    };
  } catch (error) {
    console.error('Error fetching article:', error);
    return { notFound: true };
  }
}
